import { Controller } from "stimulus";
import Cookies from "js-cookie";

function termsAccepted(cookieKey) {
  return Cookies.get(cookieKey);
}

export default class extends Controller {
  connect() {
    if (termsAccepted(this.cookieKey)) {
      this.teardown();
    } else {
      this.element.classList.remove("hidden");
    }
  }

  agree() {
    const expiresInDays = this.alwaysShow ? 0.5 : 365;

    Cookies.set(this.cookieKey, true, { expires: expiresInDays });
    this.teardown();
  }

  teardown() {
    this.element.parentNode.removeChild(this.element);
  }

  get alwaysShow() {
    return this.data.get("always-show") === "true";
  }

  get cookieKey() {
    return `dkp-map-terms-accepted-${this.data.get("map-id")}`;
  }
}
